import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggle = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', toggle);
    return () => window.removeEventListener('scroll', toggle);
  }, []);

  const scrollUp = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <button
      className={`fixed bottom-[110px] right-[38px] z-[998] w-[45px] h-[45px] rounded-full bg-[#151136] text-accent-gold text-lg flex items-center justify-center shadow-md border border-accent-gold/30 transition-all duration-300 cursor-pointer hover:bg-accent-gold hover:text-primary-deep hover:-translate-y-[3px] hover:shadow-gold-md max-md:bottom-[88px] max-md:right-5 max-md:w-10 max-md:h-10 max-md:text-base ${visible ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible translate-y-5'}`}
      onClick={scrollUp}
      aria-label="Back to top"
    >
      <FaArrowUp />
    </button>
  );
};

export default BackToTop;
